/* Lee 2.0 — cart drawer + ajax add-to-cart. Forms work without this file; everything here is enhancement. */
(function () {
  var doc = document;
  var lastFocus = null;

  function drawerRoot() { return doc.getElementById('CartDrawer'); }

  /* closed drawers must not sit in the a11y tree as modal dialogs; they gain
     dialog semantics only while open (no-JS keeps the static markup as-is) */
  function setPanelOpen(panel, open) {
    if (!panel) return;
    if (open) {
      panel.removeAttribute('inert');
      panel.removeAttribute('aria-hidden');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
    } else {
      panel.setAttribute('inert', '');
      panel.setAttribute('aria-hidden', 'true');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
    }
  }

  function panelFor(cls) {
    if (cls === 'drawer-open') return doc.querySelector('#CartDrawer .drawer');
    if (cls === 'menu-open') return doc.querySelector('#MenuDrawer .mdrawer');
    if (cls === 'search-open') return doc.querySelector('#SearchOverlay .so-panel');
    return null;
  }

  ['drawer-open', 'menu-open', 'search-open'].forEach(function (cls) {
    setPanelOpen(panelFor(cls), doc.documentElement.classList.contains(cls));
  });

  function rememberFocus() {
    if (!doc.documentElement.className.match(/drawer-open|menu-open|search-open/)) lastFocus = doc.activeElement;
  }

  function restoreFocus() {
    if (doc.documentElement.className.match(/drawer-open|menu-open|search-open/)) return;
    if (lastFocus && doc.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function openDrawer() {
    if (!drawerRoot()) return;
    rememberFocus();
    doc.documentElement.classList.add('drawer-open');
    var panel = drawerRoot().querySelector('.drawer');
    setPanelOpen(panel, true);
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!doc.documentElement.classList.contains('drawer-open')) return;
    doc.documentElement.classList.remove('drawer-open');
    setPanelOpen(panelFor('drawer-open'), false);
    restoreFocus();
  }

  function updateDots(count) {
    var links = doc.querySelectorAll('.nav-icons a[href$="/cart"]');
    for (var i = 0; i < links.length; i++) {
      var dot = links[i].querySelector('.cart-dot');
      if (count > 0) {
        if (!dot) {
          dot = doc.createElement('span');
          dot.className = 'cart-dot';
          links[i].appendChild(dot);
        }
        dot.textContent = count;
        dot.classList.remove('bump');
        void dot.offsetWidth; /* restart the animation */
        dot.classList.add('bump');
      } else if (dot) {
        dot.parentNode.removeChild(dot);
      }
    }
  }

  function applySection(html) {
    var cur = drawerRoot();
    if (!cur || !html) return;
    var t = doc.createElement('div');
    t.innerHTML = html;
    var fresh = t.querySelector('#CartDrawer');
    if (!fresh) return;
    cur.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-item-count') || '0';
    cur.setAttribute('data-item-count', count);
    updateDots(parseInt(count, 10));
    var panel = cur.querySelector('.drawer');
    var isOpen = doc.documentElement.classList.contains('drawer-open');
    setPanelOpen(panel, isOpen);
    if (isOpen && panel) panel.focus({ preventScroll: true });
  }

  function changeLine(line, quantity, busyEl) {
    if (busyEl) busyEl.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { applySection(d.sections && d.sections['cart-drawer']); })
      .catch(function () { if (busyEl) busyEl.disabled = false; });
  }

  /* rail attribution (2026-09-22): a rail card click carries ?rail=<rail>:<pos>. Remember it for THIS product page
     only, attach it as the hidden line property _rail on the next ajax add-to-cart here that does not already carry
     one, and forget it once that add succeeds. Values are validated; storage failures are ignored. */
  var RAIL_KEY = 'lee_rail';
  (function () {
    var m = window.location.search.match(/[?&]rail=([^&#]+)/);
    if (!m) return;
    var val;
    try { val = decodeURIComponent(m[1]); } catch (err) { return; }
    if (!/^[a-z-]+:\d{1,3}$/.test(val)) return;
    try { window.sessionStorage.setItem(RAIL_KEY, JSON.stringify({ r: val, p: window.location.pathname })); } catch (err) { /* storage blocked */ }
  })();
  function peekRail() {
    try {
      var raw = window.sessionStorage.getItem(RAIL_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      return (v && v.p === window.location.pathname) ? v.r : null;
    } catch (err) { return null; }
  }
  function clearRail() { try { window.sessionStorage.removeItem(RAIL_KEY); } catch (err) { /* ignore */ } }

  /* ajax add-to-cart: stay on the page, animate, open the drawer */
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!window.fetch || !window.FormData) return; /* native submit */
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var fd = new FormData(f);
    var rail = null;
    if (!f.querySelector('[name="properties[_rail]"]')) {
      rail = peekRail();
      if (rail) fd.append('properties[_rail]', rail);
    }
    fd.append('sections', 'cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        if (rail) clearRail();
        applySection(d.sections && d.sections['cart-drawer']);
        if (btn) {
          btn.classList.add('added');
          if (btn.childElementCount === 0 && btn.textContent.replace(/\s/g, '')) {
            if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
            btn.textContent = 'Added ✓';
          }
          setTimeout(function () {
            btn.classList.remove('added');
            var label = btn.getAttribute('data-label');
            if (label) btn.textContent = label;
          }, 1100);
        }
        openDrawer();
      })
      .catch(function () { f.submit(); }); /* sold out / errors: let the server answer */
  });

  function openLayer(cls, focusSel) {
    rememberFocus();
    doc.documentElement.classList.add(cls);
    setPanelOpen(panelFor(cls), true);
    var el = focusSel && doc.querySelector(focusSel);
    if (el) el.focus({ preventScroll: true });
  }
  function closeLayer(cls) {
    if (!doc.documentElement.classList.contains(cls)) return;
    doc.documentElement.classList.remove(cls);
    setPanelOpen(panelFor(cls), false);
    restoreFocus();
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;

    var groupParent = t.closest('.nav-links > li > a[href="#"]');
    if (groupParent) { e.preventDefault(); return; } /* hover/focus opens the dropdown; the link itself goes nowhere */

    var closeEl = t.closest('[data-drawer-close]');
    if (closeEl) {
      closeDrawer();
      if (closeEl.tagName !== 'A') e.preventDefault();
      return;
    }

    var menuClose = t.closest('[data-menu-close]');
    if (menuClose) { e.preventDefault(); closeLayer('menu-open'); return; }

    var searchClose = t.closest('[data-search-close]');
    if (searchClose) { e.preventDefault(); closeLayer('search-open'); return; }

    var menuBtn = t.closest('.nav-toggle');
    if (menuBtn && doc.getElementById('MenuDrawer')) {
      e.preventDefault();
      openLayer('menu-open', '#MenuDrawer .mdrawer');
      return;
    }

    var searchBtn = t.closest('.nav-search-open');
    if (searchBtn && doc.getElementById('SearchOverlay')) {
      e.preventDefault();
      openLayer('search-open', '#SearchOverlay input[type="search"]');
      return;
    }

    var cartLink = t.closest('.nav-icons a[href$="/cart"]');
    if (cartLink && drawerRoot()) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var qb = t.closest('[data-qty-change]');
    if (qb) {
      e.preventDefault();
      var q = parseInt(qb.getAttribute('data-qty-change'), 10);
      changeLine(parseInt(qb.getAttribute('data-line'), 10), q < 0 ? 0 : q, qb);
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    changeLine(parseInt(input.getAttribute('data-line'), 10), isNaN(q) || q < 0 ? 0 : q, input);
  });

  /* hero carousel: hash-free dots, active state, autoplay */
  (function () {
    var car = doc.querySelector('.hero-car');
    if (!car) return;
    var track = car.querySelector('.hero-track');
    var dots = [].slice.call(car.querySelectorAll('.hero-dots a'));
    var n = track.children.length;
    if (n < 2) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { track.scrollTo({ left: track.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' }); }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(i); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = index();
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
      });
    }, { passive: true });
    if (dots[0]) dots[0].classList.add('on');
    /* reduced-motion users still get the rotation (explicitly requested) but as instant jumps — go() uses behavior:auto for them; hover/focus pauses it for everyone */
    var timer = null;
    function start() { stop(); timer = setInterval(function () { go((index() + 1) % n); }, 4000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    car.addEventListener('pointerenter', stop);
    car.addEventListener('pointerleave', start);
    car.addEventListener('focusin', stop);
    car.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : start(); });
    start();
  })();

  /* PDP recommendations: try merchant-curated complementary, fall back to related */
  (function () {
    var wrap = doc.querySelector('[data-recommendations-url]');
    if (!wrap || !window.fetch) return;
    function load(intent, onEmpty) {
      fetch(wrap.getAttribute('data-recommendations-url') + '&intent=' + intent)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var t = doc.createElement('div');
          t.innerHTML = html;
          var fresh = t.querySelector('[data-recommendations-url]');
          if (fresh && fresh.querySelectorAll('.mini').length > 0) {
            wrap.innerHTML = fresh.innerHTML;
          } else if (onEmpty) {
            onEmpty();
          }
        })
        .catch(function () { if (onEmpty) onEmpty(); });
    }
    load('complementary', function () { load('related'); });
  })();

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeLayer('menu-open');
      closeLayer('search-open');
      return;
    }
    if (e.key !== 'Tab') return;
    var root = doc.documentElement;
    var panel = root.classList.contains('drawer-open') ? doc.querySelector('#CartDrawer .drawer')
      : root.classList.contains('menu-open') ? doc.querySelector('#MenuDrawer .mdrawer')
      : root.classList.contains('search-open') ? doc.querySelector('#SearchOverlay .so-panel')
      : null;
    if (!panel) return;
    var els = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary');
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    var inside = panel.contains(doc.activeElement);
    if (e.shiftKey && (doc.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (doc.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });
})();
